export function getPostLoginDestination(search: string) {
  const postLogin = new URLSearchParams(search).get('post_login');
  return postLogin === 'dashboard' ? '/dashboard' : null;
}
